import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	submit_email, log_isda_information_to_icms, set_email_error
} from '../actions/index';

import '../global';

class EmailAddressInput extends Component {

	constructor( props ) {
		super( props );
		this.state = {
			email: '', error_class: '', error_message: '', loading: false
		};

		this.handleChange = this.handleChange.bind( this );
	}

	handleChange( event ) {
		this.setState( { email: event.target.value } );
	}

	validateEmail( email ) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test( String( email ).toLowerCase() );
	}

	handleClick( email ) {
		if ( this.validateEmail( email ) === false ) {
			this.setErrors( 'Please provide a valid email address.' );
		} else {
			this.props.submit_email( email );
			let state = this.state;
			state.loading = true;
			this.setState( state );
		}
	}

	setErrors( errorMessage ) {
		let state = this.state;
		state.error_message = (<div class="help-block with-errors">
			<ul class="list-unstyled">
				<li>{ errorMessage }</li>
			</ul>
		</div>
		);
		state.error_class = 'has-error has-danger';
		state.loading = false;
		this.props.set_email_error( false );
		this.setState( state );
	}

	handleCompanyClick( email, company ) {
		let data = {
			company_name: company.COMPANY, company_id: company.ID, email: email
		};
		this.props.log_isda_information_to_icms( data );
	}

	showAdditionalCompanies() {
		let companies = this.props.all_companies_for_email.data.map( company => (
			<div class="company-name" onClick={ this.handleCompanyClick.bind( this, this.props.all_companies_for_email.email, company ) }>{ company.COMPANY }</div>
		) );
		let title = (
			<div class="select-company-title">Please select your company:</div>
		);
		companies.unshift( title );
		return companies;
	}

	render() {
		if ( this.props.email_error === true ) {
			this.setErrors( 'The email address you entered is not with a valid company. Please provide another email address or contact membership.' );
		}
		let additionalCompanies = '';
		let submitButton = (
			<button class="submit-email" onClick={ this.handleClick.bind( this, this.state.email ) }>Submit</button>
		);
		let inputField = (
			<input class="form-control" id="email-input" type="text" placeholder='Business Email / Username' value={ this.state.email } onChange={ this.handleChange } />
		);
		if ( this.props.all_companies_for_email !== false ) {
			additionalCompanies = this.showAdditionalCompanies();
			submitButton = (<button class="submit-email" disabled>Submit</button>
			);
			inputField = (
				<input class="form-control" id="email-input" type="text" placeholder='Business Email / Username' value={ this.state.email } disabled />
			);

		}
		if ( this.state.loading === true && this.props.all_companies_for_email === false ) {
			submitButton = (<button class="submit-email" disabled>
				<img src="/wp-content/themes/isda-theme-underscores/images/ajax-loader.gif" />
			</button>
			);
			inputField = (
				<input class="form-control" id="email-input" type="text" placeholder='Business Email / Username' value={ this.state.email } disabled />
			);
		}

		return (<div class={ 'email-input-container ' + this.state.error_class }>
			<label for="email-input" class="control-label email-label">Please enter your business email to participate in Roll Call Attendance</label>
			{ inputField }
			{ submitButton }
			{ additionalCompanies }
			{ this.state.error_message }
		</div>
		);
	}

}

function mapStateToProps( { all_companies_for_email, email_error } ) {
	return { all_companies_for_email, email_error };
}

export default connect( mapStateToProps, {
	submit_email,
	log_isda_information_to_icms,
	set_email_error
} )( EmailAddressInput );